//this analytics file is the reporting system of all the web application


//This function is used to send tracking information to Google Analytics.
// eventName → the name of the event you want to track.
// params → extra information about that event. It defaults to an empty object {}.
// This checks two things before tracking:
// window exists.
// window.gtag exists and is actually a function.
// gtag is the Google Analytics function used to send tracking events.
// Your React app
//       ↓
// trackEvent()
//       ↓
// Check if Google Analytics exists
//       ↓
// Send event + information
//       ↓
// Google Analytics
const trackEvent = (eventName, params = {}) => {//params extract the extra information about the event
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
};




export const trackGameSelect = (gameName, gameUuid) => {
  trackEvent('game_select', {
    module: 'home',
    game_name: gameName,
    game_uuid: gameUuid
  });
};


//view/game.jsx
export const trackTabAttempt = (tabName, currentLevel, page = 'home') => {
  trackEvent('skill_tab_attempt', {
    module: 'navigation',
    attempted_tab: tabName,
    current_skill_level: currentLevel,
    page_location: page
  });
};

//view/game.jsx
export const trackTabSuccess = (tabName, currentLevel, page = 'home') => {
  trackEvent('skill_tab_success', {
    module: 'navigation',
    selected_tab: tabName,
    current_skill_level: currentLevel,
    page_location: page
  });
};

//view/game.jsx
export const trackTabBlocked = (tabName, currentLevel, reason, page = 'home') => {
  trackEvent('skill_tab_blocked', {
    module: 'navigation',
    attempted_tab: tabName,
    current_skill_level: currentLevel,
    block_reason: reason,
    page_location: page
  });
};


//So this function does not open the dialog. It only records/tracks that the dialog was opened.
// eventName = "test_skills_dialog_open"
// params = { module: "gameplay" }
export const trackTestSkillsDialogOpen = (skillLevel) => {
  trackEvent('test_skills_dialog_open', {
    module: 'gameplay',
    current_skill_level: skillLevel
  });
};

export const trackPlayNowClick = (skillLevel) => {
  trackEvent('play_now_click', {
    module: 'gameplay',
    current_skill_level: skillLevel
  });
};


// It takes 2 values:
// skillLevel → user's current skill level, such as "beginner", "rookie", or "pro".
// playedGame → whether the user played a game before closing the dialog.
// Default value is false.

// This function tells the analytics system that the Test Skills dialog was closed, and records the user's skill level and whether they played a game before closing it.
export const trackTestSkillsDialogClose = (skillLevel, playedGame = false) => {
  trackEvent('test_skills_dialog_close', {
    module: 'gameplay',
    current_skill_level: skillLevel,
    played_game: playedGame
  });
};

//features/play/GAFps
export const trackGameStart = () => {
  trackEvent('aimtrain_game_start', {
    module: 'gameplay',
    start_timestamp: Date.now()
  });
};

//features/play/GAFps
export const trackGameEnd = (durationSeconds, reason = 'component_unmount') => {
  trackEvent('aimtrain_game_end', {
    module: 'gameplay',
    duration_seconds: Math.round(durationSeconds),
    duration_minutes: Math.round(durationSeconds / 60 * 100) / 100,
    end_reason: reason
  });
};

//features/play/GAFps
export const trackGameError = (errorType) => {
  trackEvent('aimtrain_game_error', {
    module: 'gameplay',
    error_type: errorType
  });
};


//This function is used to track/log when a user tries to edit their profile. It likely sends an event to an analytics system.
//view/profile.jsx
export const trackProfileEditAttempt = () => {
  trackEvent('profile_edit_attempt', {//Record that the user attempted to edit their profile.
    module: 'profile'//Tell the analytics system that this event belongs to the profile module.
  });
};

//The difference is that it tracks a successful profile edit, not just an attempt.
//view/profile.jsx
export const trackProfileEditSuccess = () => {
  trackEvent('profile_edit_success', {//Tell the analytics system that the profile edit was successful.
    module: 'profile'//This event belongs to the profile section.
  });
};



//This function tracks when a profile edit fails.it also receives the error message so you can know why it failed.
//view/profile.jsx
export const trackProfileEditFailure = (errorMessage) => {
  trackEvent('profile_edit_failure', {//Record that the profile edit failed.
    module: 'profile',//This failure happened in the profile section.
    error_message: errorMessage//Send the actual error message along with the failure event.
  });
};

//view/puzzle.jsx
export const trackPuzzleView = (puzzleId, puzzleName) => {
  trackEvent('puzzle_view', {
    module: 'puzzle',
    puzzle_id: puzzleId,
    puzzle_name: puzzleName
  });
};

export const trackEasterEggUnlockAttempt = (puzzleId, partId) => {
  trackEvent('easter_egg_unlock_attempt', {
    module: 'puzzle',
    puzzle_id: puzzleId,
    part_id: partId
  });
};

export const trackEasterEggUnlockSuccess = (puzzleId, partId) => {
  trackEvent('easter_egg_unlock_success', {
    module: 'puzzle',
    puzzle_id: puzzleId,
    part_id: partId
  });
};

export const trackEasterEggUnlockFailure = (puzzleId, partId, errorMessage) => {
  trackEvent('easter_egg_unlock_failure', {
    module: 'puzzle',
    puzzle_id: puzzleId,
    part_id: partId,
    error_message: errorMessage
  });
};
//view/puzzle.jsx
export const trackPuzzleComplete = (puzzleId, puzzleName) => {
  trackEvent('puzzle_complete', {
    module: 'puzzle',
    puzzle_id: puzzleId,
    puzzle_name: puzzleName
  });
};

export const trackEasterEggPopupShown = (podcastId, easterEggCode) => {
  trackEvent('easter_egg_popup_shown', {
    module: 'video',
    podcast_id: podcastId,
    easter_egg_code: easterEggCode
  });
};

export const trackEasterEggPopupClosed = (podcastId, codeCopied = false) => {
  trackEvent('easter_egg_popup_closed', {
    module: 'video',
    podcast_id: podcastId,
    code_copied: codeCopied
  });
};
//view/puzzle.jsx
export const trackRedeemDialogOpen = (puzzleId, puzzleName) => {
  trackEvent('redeem_dialog_open', {
    module: 'redemption',
    puzzle_id: puzzleId,
    puzzle_name: puzzleName
  });
};

export const trackRedeemItemSelect = (puzzleId, itemId, itemName) => {
  trackEvent('redeem_item_select', {
    module: 'redemption',
    puzzle_id: puzzleId,
    item_id: itemId,
    item_name: itemName
  });
};
//view/puzzle.jsx
export const trackRedeemAttempt = (puzzleId, itemId) => {
  trackEvent('redeem_attempt', {
    module: 'redemption',
    puzzle_id: puzzleId,
    item_id: itemId
  });
};
//view/puzzle.jsx
export const trackRedeemKoFailure = (puzzleId, itemId, detailsMessage) => {
  trackEvent('redeem_ko_failure', {
    module: 'redemption',
    puzzle_id: puzzleId,
    item_id: itemId,
    failure_reason: detailsMessage
  });
};
//view/puzzle.jsx
export const trackRedeemError = (puzzleId, itemId, errorMessage) => {
  trackEvent('redeem_error', {
    module: 'redemption',
    puzzle_id: puzzleId,
    item_id: itemId,
    error_message: errorMessage
  });
};
//view/puzzle.jsx
export const trackRedeemProceedToSubmit = (puzzleId, itemName) => {
  trackEvent('redeem_proceed_to_submit', {
    module: 'redemption',
    puzzle_id: puzzleId,
    item_name: itemName
  });
};

//view/submitredeem.jsx
export const trackClaimFormSubmit = (itemName) => {
  trackEvent('claim_form_submit', {
    module: 'redemption',
    item_name: itemName
  });
};

//view/submitredeem.jsx
export const trackRedemptionSuccess = (itemName, puzzleId) => {
  trackEvent('redemption_success', {
    module: 'redemption',
    item_name: itemName,
    puzzle_id: puzzleId
  });
};
//view/submitredeem.jsx
export const trackRedemptionFailure = (itemName, puzzleId, errorMessage) => {
  trackEvent('redemption_failure', {
    module: 'redemption',
    item_name: itemName,
    puzzle_id: puzzleId,
    error_message: errorMessage
  });
};
